import type { LucideIcon } from 'lucide-react';

import { StatCard, type StatTone } from '../../../components/ui/index.js';

export interface KpiCardProps {
  label: string;
  value: string;
  /** Secondary value or hint shown below the main value. */
  hint?: string;
  /** Sign-aware delta vs. comparison period. Coloured by sign. */
  delta?: { value: string; positive: boolean } | null;
  icon?: LucideIcon;
  tone?: StatTone;
  /** Skeleton placeholder while the underlying request is in flight. */
  loading?: boolean;
}

/**
 * Compact KPI card used across the statistics + report headers. Thin wrapper
 * over the shared {@link StatCard} so reports share the dashboard's
 * interactive accent treatment; pick a tone that matches the metric
 * (e.g. revenue=success, expenses=warning, overdue=danger).
 */
export function KpiCard({
  label,
  value,
  hint,
  delta,
  icon,
  tone = 'neutral',
  loading,
}: KpiCardProps): JSX.Element {
  return (
    <StatCard
      label={label}
      value={value}
      loading={loading}
      icon={icon}
      tone={tone}
      delta={delta}
      hint={hint}
    />
  );
}
